import { fromJS, Map } from "immutable";

export default (rows) => {
  var data = fromJS(rows);
  return Map(data.map((e) => e.get("id")).zip(data));
};
